import { CustomReportsRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

function ReportsCustomReportsRoute() {
  const { workspaceId } = Route.useParams();
  return <CustomReportsRoute segment="reports" workspaceId={workspaceId} />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/reports/custom-reports/')({
  component: ReportsCustomReportsRoute,
});
